module.exports = __webpack_public_path__ + "img/rappi.0c080f13.png";